import { defineTool, type Permission } from '@/shell/tool';

/**
 * Editing the badge catalog changes what every tutor holding a badge is paid, so it is a grant of
 * its own rather than part of opening the tool (`badges-live-on-the-tutor` D4). The old admin drew
 * the same line: `tutorBadgesUsers`, coloured "danger" in its permissions screen.
 */
export const MANAGE_BADGES: Permission = 'tutor-badges:manage';

/** Tutors (Flutter `/tutors`), and the badges a tutor holds (Flutter `/tutor-badges`). */
export default defineTool({
  id: 'tutors',
  title: 'Tutors',
  summary:
    'Find a tutor, and read their profile, their lessons, their payments and the badges they hold.',
  section: 'users',
  order: 40,
  icon: 'group',
  owner: '@Drabu',
  permission: 'tutors:use',
  grants: [MANAGE_BADGES],
  routes: () => import('./TutorsPage'),
});
